var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 .983 2.626L7.912 9.162a4 4 0 0 1 0 1.676l5.071 2.536a4 4 0 1 1-.895 1.789l-5.071-2.537a4 4 0 1 1 0-5.253l5.071-2.535A4 4 0 0 1 12 4M4 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m12 6a2 2 0 1 0-.001 4A2 2 0 0 0 16 14",
    clipRule: "evenodd"
  })));
};
export default SvgShare;